import { j as r } from "./kezios-design-system.esm172.js";
import { Alert as c } from "@mantine/core";
import { IconAlertCircle as i } from "./kezios-design-system.esm5.js";
import { IconInfoCircle as s } from "./kezios-design-system.esm54.js";
import { IconFlame as l } from "./kezios-design-system.esm50.js";
import { IconAlertTriangle as m } from "./kezios-design-system.esm6.js";
import { IconLightBulb04 as a } from "./kezios-design-system.esm71.js";
const o = 20, u = (e) => {
  switch (e) {
    case "tip":
      return /* @__PURE__ */ r.jsx(a, { size: o, color: "green.7" });
    case "caution":
      return /* @__PURE__ */ r.jsx(m, { size: o, color: "yellow.9" });
    case "danger":
      return /* @__PURE__ */ r.jsx(l, { size: o, color: "red.9" });
    case "note":
      return /* @__PURE__ */ r.jsx(s, { size: o, color: "gray.9" });
    case "info":
      return /* @__PURE__ */ r.jsx(i, { size: o, color: "blue.9" });
    default:
      return;
  }
}, d = ({ title: e = void 0, type: t, children: n }) => /* @__PURE__ */ r.jsx(
  c,
  {
    title: e,
    variant: `${t}${e ? "" : ".noTitle"}`,
    icon: u(t),
    children: n
  }
);
export {
  d as DocTip
};
